import {
    FORGOT_PASSWORD,
    SET_PASSWORD,
    LOGIN_COMPONENT
} from './UserLoginActionTypes';

export function setPassword(email) {
    return {
        type: SET_PASSWORD,
        email
    };
}

export function forgotPassword() {
    return {
        type: FORGOT_PASSWORD
    };
}

export function loginComponent() {
    return {
        type: LOGIN_COMPONENT
    };
}
